export const ADMIN_HOME = "/home"

/* Business units */
export const VIEW_BUSINESS_UNITS = "/countries/view"
export const ADD_BUSINESS_UNITS = "/countries/add"

/** People */
export const PEOPLE = "/people"
export const ADD_PEOPLE_SINGLE = "/people/add/single"
export const ADD_PEOPLE_MULTIPLE = "/people/add/multiple"
export const UPDATE_PEOPLE_MULTIPLE = "/people/update/multiple"
export const BULK_DEACTIVATE_PEOPLE = "/people/deactivate"
export const VIEW_PEOPLE = "/people/view"

/** Teams */
export const TEAMS = "/teams"
export const VIEW_TEAM = "/teams/view"
export const ADD_TEAM = "/teams/add"
export const ASSIGN_MANAGERS = "/teams/assignManagers"
export const ASSIGN_MEMBERS = "/teams/assignMembers"

/**
 * Settings
 * - customisation
 * - roles and permissions
 * - login and integrations
 */
export const SETTINGS_BASE = "/settings"

export const SETTINGS_CUSTOMISE = "/settings/customisation"
export const SETTINGS_CUSTOMISE_BRAND = `${SETTINGS_CUSTOMISE}/brand`
export const SETTINGS_CUSTOMISE_WELCOME_EMAIL = `${SETTINGS_CUSTOMISE}/welcome-message`
export const SETTINGS_CUSTOMISE_PERKS_VISIBILITY = `${SETTINGS_CUSTOMISE}/perk-visibility`
export const SETTINGS_CUSTOMISE_BENEFITS = `${SETTINGS_CUSTOMISE}/benefits`
export const SETTINGS_CUSTOMISE_BENEFITS_SETTINGS = `${SETTINGS_CUSTOMISE}/benefits/settings`
export const SETTINGS_CUSTOMISE_VALUES = `${SETTINGS_CUSTOMISE}/values`
export const SETTINGS_CUSTOMISE_CELEBRATIONS = `${SETTINGS_CUSTOMISE}/celebrations`

/** Roles and permissions */
export const SETTINGS_PERMISSIONS_RECOGNITION = `${SETTINGS_BASE}/roles-and-permissions/recognition`

/** Login and integrations */
export const SETTINGS_LOGIN_SSU = `${SETTINGS_BASE}/login/ssu`
export const SETTINGS_LOGIN_SSO = `${SETTINGS_BASE}/login/sso`
export const SETTINGS_LOGIN_INTEGRATION = `${SETTINGS_BASE}/login/integration`
export const SETTINGS_LOGIN_INTEGRATION_SSO = `${SETTINGS_LOGIN_INTEGRATION}/sso`
export const SETTINGS_LOGIN_INTEGRATION_DSYNC = `${SETTINGS_LOGIN_INTEGRATION}/dsync`
export const SETTINGS_LOGIN_INTEGRATION_CHECKLIST_SSO = `${SETTINGS_LOGIN_INTEGRATION_SSO}/checklist`
export const SETTINGS_LOGIN_INTEGRATION_CUSTOMIZE_SSO = `${SETTINGS_LOGIN_INTEGRATION_SSO}/custom`
export const SETTINGS_LOGIN_INTEGRATION_CHECKLIST_DSYNC = `${SETTINGS_LOGIN_INTEGRATION_DSYNC}/checklist`

/** Analytics */
export const ANALYTICS_BASE = "/analytics"
export const ANALYTICS_OVERALL = `${ANALYTICS_BASE}/overall`
export const ANALYTICS_CELEBRATIONS = `${ANALYTICS_BASE}/celebrations`
export const ANALYTICS_PERKS = `${ANALYTICS_BASE}/perks`

/** Help */
export const HELP = "/help"

/** Billing */
export const BILLING = "/billing"

/** Automation */
export const AUTOMATION_BASE = "/automation"
export const AUTOMATION_LIST = "/view"
export const AUTOMATION_CREATE = "/create/:uuid"
export const AUTOMATION_EDIT = "/edit/:uuid"
